export const contents = [
  {
    id: "wugang-huisheng",
    title: "雾港回声",
    categoryId: "movie",
    region: "中国香港",
    year: 2024,
    genres: ["悬疑", "剧情"],
    tags: ["国语对白", "高清", "烧脑", "口碑"],
    director: "陈映川",
    cast: ["林嘉树", "苏曼青", "周鹤鸣"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20of%20a%20foggy%20harbor%20at%20night%2C%20moody%20deep%20blue%20tones%20with%20warm%20lamp%20glow%2C%20mysterious%20atmosphere%2C%20minimal%20elegant%20composition&width=600&height=900&seq=gydb-c01&orientation=portrait",
    summary: "一桩沉寂多年的旧案随潮水重浮水面，港口女警在迷雾里追寻真相。",
    description: [
      "雾港的清晨总是被水汽裹着，码头上的旧仓库里发现了一封未寄出的信。女警程未晞顺着一连串错位的证词，重新翻开十年前的悬案卷宗。",
      "随着调查深入，每个证人都在刻意回避某个名字。真相藏在潮汐涨落的间隙里，而她必须先面对自己与这桩案件隐秘的关联。",
    ],
    views: 48320,
    updatedAt: "2026-09-28",
    rating: 9.1,
  },
  {
    id: "changan-yexing",
    title: "长安夜行",
    categoryId: "movie",
    region: "中国大陆",
    year: 2023,
    genres: ["历史", "剧情"],
    tags: ["国语对白", "经典", "时代记忆", "高分"],
    director: "顾长风",
    cast: ["沈既明", "柳如烟", "裴仲安"],
    cover: "https://readdy.ai/api/search-image?query=ancient%20chinese%20city%20street%20at%20night%20with%20lanterns%2C%20cinematic%20historical%20drama%20poster%2C%20deep%20blue%20sky%20with%20warm%20orange%20lantern%20light%2C%20elegant%20composition&width=600&height=900&seq=gydb-c02&orientation=portrait",
    summary: "盛世夜色之下，一名小吏用一夜时间揭开长安城暗涌的秘密。",
    description: [
      "上元灯节的长安城灯火如昼，却有人在最热闹的时辰失踪。负责案牍的小吏陆行舟被迫卷入一场牵动多方的暗局。",
      "从朱雀大街到西市酒肆，他在一夜之间走过半座城，也走过人心的明暗。史书只留下寥寥数笔，而这一夜值得被记住。",
    ],
    views: 39150,
    updatedAt: "2026-09-20",
    rating: 8.8,
  },
  {
    id: "shenhai-huisheng",
    title: "深海回声",
    categoryId: "movie",
    region: "中国大陆",
    year: 2025,
    genres: ["科幻", "悬疑"],
    tags: ["国语对白", "新片", "高清", "烧脑"],
    director: "韩知远",
    cast: ["江屿", "何清晏", "罗一鸣"],
    cover: "https://readdy.ai/api/search-image?query=sci-fi%20movie%20poster%20of%20deep%20ocean%20trench%20with%20glowing%20blue%20light%20and%20submarine%20silhouette%2C%20futuristic%20moody%20atmosphere%2C%20cinematic%20composition&width=600&height=900&seq=gydb-c03&orientation=portrait",
    summary: "深海科考站收到一段来自海底的信号，它重复着一名失踪队员的名字。",
    description: [
      "在七千米深的海沟里，科考队建立起人类最深的观测站。某天，设备捕捉到一段有规律的声波，破译后竟是失踪三年的队员姓名。",
      "当队员们循着信号下潜，等待他们的不只是未知的生物，还有关于记忆与身份的追问。深海的回声，究竟来自哪里？",
    ],
    views: 52860,
    updatedAt: "2026-10-02",
    rating: 8.9,
  },
  {
    id: "chunri-duanzan",
    title: "春日短暂",
    categoryId: "movie",
    region: "中国台湾",
    year: 2022,
    genres: ["爱情", "剧情"],
    tags: ["国语对白", "治愈", "温情", "口碑"],
    director: "许知夏",
    cast: ["郑念安", "林小雨", "吴承言"],
    cover: "https://readdy.ai/api/search-image?query=soft%20romantic%20film%20poster%20with%20spring%20blossoms%20and%20warm%20sunlight%2C%20pastel%20tone%2C%20gentle%20lyrical%20atmosphere%2C%20minimal%20elegant%20composition&width=600&height=900&seq=gydb-c04&orientation=portrait",
    summary: "一整个春天，两个错过的人在一间旧书店里反复相遇又告别。",
    description: [
      "城市的旧书店即将拆迁，店主阿念决定用一个春天，整理完所有未售出的旧书，也整理完自己没说出口的心事。",
      "常来买书的是位总戴着耳机的年轻人，他们从一本诗集聊到各自的过去。春日短暂，而有些告别值得慢慢来。",
    ],
    views: 27640,
    updatedAt: "2026-08-15",
    rating: 8.5,
  },
  {
    id: "xiangkou-yanhuo",
    title: "巷口烟火",
    categoryId: "tv",
    region: "中国大陆",
    year: 2024,
    genres: ["都市", "家庭"],
    tags: ["国语对白", "温情", "治愈", "连载中"],
    director: "王志远",
    cast: ["李慧珍", "张建国", "周小雨"],
    cover: "https://readdy.ai/api/search-image?query=warm%20chinese%20neighborhood%20alley%20street%20in%20the%20evening%2C%20family%20drama%20tv%20poster%2C%20soft%20orange%20light%20with%20blue%20dusk%2C%20cozy%20lively%20atmosphere&width=600&height=900&seq=gydb-c05&orientation=portrait",
    summary: "老巷子里三家邻居的日常，把一座城市的烟火气熬成了最暖的故事。",
    description: [
      "巷口那家开着三十年的早餐铺，是整条街的时间坐标。老板娘李慧珍守着这方小小的灶台，也守着街坊们的喜怒哀乐。",
      "从孩子高考到老人退休，从旧店拆迁到新邻搬来，三十六集里装下的是一整条巷子的春夏秋冬。",
    ],
    views: 61230,
    updatedAt: "2026-10-05",
    rating: 8.7,
  },
  {
    id: "niguang-erxing",
    title: "逆光而行",
    categoryId: "tv",
    region: "中国大陆",
    year: 2023,
    genres: ["剧情", "悬疑"],
    tags: ["国语对白", "烧脑", "高分", "已完结"],
    director: "孟凡舟",
    cast: ["顾南川", "苏染", "谢天成"],
    cover: "https://readdy.ai/api/search-image?query=moody%20urban%20serial%20drama%20poster%20with%20silhouette%20walking%20against%20backlight%2C%20deep%20blue%20tones%20with%20warm%20rim%20light%2C%20cinematic%20suspense%20atmosphere&width=600&height=900&seq=gydb-c06&orientation=portrait",
    summary: "一名坚持十年的记者，在逆光的城市里追逐一桩被遗忘的旧事。",
    description: [
      "记者顾南川用十年时间追查一起早已结案的工厂事故，所有人都劝他放下，只有他相信纸面上的结论并非全部真相。",
      "随着采访对象一个个改变说法，他意识到真正的阻力不在程序，而在人心。二十集篇幅，讲一个不肯转身的人。",
    ],
    views: 44580,
    updatedAt: "2026-09-11",
    rating: 9.0,
  },
  {
    id: "haifeng-zhiwoyi",
    title: "海风知我意",
    categoryId: "tv",
    region: "中国台湾",
    year: 2022,
    genres: ["爱情", "都市"],
    tags: ["国语对白", "治愈", "口碑", "已完结"],
    director: "林佩瑜",
    cast: ["陈以宁", "黄宇航", "苏婉婷"],
    cover: "https://readdy.ai/api/search-image?query=seaside%20town%20with%20gentle%20waves%20and%20evening%20light%2C%20romantic%20tv%20drama%20poster%2C%20soft%20blue%20sea%20with%20warm%20orange%20sunset%2C%20lyrical%20atmosphere&width=600&height=900&seq=gydb-c07&orientation=portrait",
    summary: "回到海边小镇的姑娘，重新遇见那个曾经不告而别的少年。",
    description: [
      "以宁辞掉大城市的广告工作，回到海边的老家接手外婆留下的小民宿。第一晚就到访的客人，是多年前不告而别的航宇。",
      "海风把两个成年人的客套一层层吹散，露出当年没说清的误会。这是一部关于和解与重新出发的温柔剧集。",
    ],
    views: 33290,
    updatedAt: "2026-07-28",
    rating: 8.4,
  },
  {
    id: "chenmo-de-zhengci",
    title: "沉默的证词",
    categoryId: "tv",
    region: "中国香港",
    year: 2021,
    genres: ["悬疑", "剧情"],
    tags: ["国语对白", "烧脑", "经典", "已完结"],
    director: "高文博",
    cast: ["陈家豪", "李欣桐", "麦志峰"],
    cover: "https://readdy.ai/api/search-image?query=dark%20interrogation%20room%20with%20single%20lamp%2C%20crime%20thriller%20tv%20poster%2C%20deep%20blue%20shadows%20with%20warm%20lamp%20glow%2C%20tense%20atmosphere&width=600&height=900&seq=gydb-c08&orientation=portrait",
    summary: "一位法医从十几年前的旧物证里，读出了一段无人愿意开口的证词。",
    description: [
      "法医麦志峰在整理旧档案时，发现一份物证的封条日期与记录不符。这个微小的破绽，牵出一桩已经无人追问的悬案。",
      "证人保持沉默，卷宗保持沉默，可物证不会。二十五集推理长剧，献给所有不肯沉默的人。",
    ],
    views: 41020,
    updatedAt: "2026-06-19",
    rating: 8.6,
  },
  {
    id: "shanhe-shiwei",
    title: "山河食味",
    categoryId: "doc",
    region: "中国大陆",
    year: 2024,
    genres: ["家庭"],
    tags: ["国语对白", "高清", "口碑", "时代记忆"],
    director: "周作霖",
    cast: ["旁白 沈砚"],
    cover: "https://readdy.ai/api/search-image?query=steaming%20traditional%20chinese%20dishes%20on%20a%20wooden%20table%2C%20food%20documentary%20poster%2C%20warm%20earth%20tones%20with%20soft%20blue%20background%2C%20rustic%20elegant%20atmosphere&width=600&height=900&seq=gydb-c09&orientation=portrait",
    summary: "沿着山河行走，记录一方水土如何养出一餐一饭的深情。",
    description: [
      "从北方的面食到南方的米香，摄制组花三年时间走过二十四个省份，记录不同土地上的人们如何用食物安放生活。",
      "每一集围绕一种食材展开，也围绕一个家庭展开。食物从不只是食物，它是记忆，是乡愁，是最日常的深情。",
    ],
    views: 58640,
    updatedAt: "2026-09-30",
    rating: 9.3,
  },
  {
    id: "chengshi-maibo",
    title: "城市脉搏",
    categoryId: "doc",
    region: "中国大陆",
    year: 2023,
    genres: ["都市"],
    tags: ["国语对白", "高清", "纪实", "口碑"],
    director: "姜怀远",
    cast: ["旁白 程述"],
    cover: "https://readdy.ai/api/search-image?query=aerial%20view%20of%20city%20skyline%20at%20blue%20hour%20with%20lights%20turning%20on%2C%20documentary%20poster%2C%20deep%20blue%20with%20warm%20city%20lights%2C%20modern%20cinematic%20atmosphere&width=600&height=900&seq=gydb-c10&orientation=portrait",
    summary: "城市醒来的每一个清晨，都有一群人先于所有人点亮了它。",
    description: [
      "凌晨四点的公交司机、五点开始备货的菜农、六点清扫街道的环卫工——这部纪录片把镜头对准城市醒来之前的那些人。",
      "没有旁白式的煽情，只有安静的跟拍。当城市开始喧嚣，这些人的一天才刚刚过半。",
    ],
    views: 35970,
    updatedAt: "2026-08-22",
    rating: 8.8,
  },
  {
    id: "jiangxin-shouji",
    title: "匠心手记",
    categoryId: "doc",
    region: "中国大陆",
    year: 2022,
    genres: ["剧情"],
    tags: ["国语对白", "纪实", "治愈", "时代记忆"],
    director: "陆敬之",
    cast: ["旁白 苏怀"],
    cover: "https://readdy.ai/api/search-image?query=artisan%20hands%20crafting%20pottery%20in%20warm%20workshop%20light%2C%20documentary%20poster%2C%20warm%20earthy%20tones%20with%20deep%20background%2C%20quiet%20refined%20atmosphere&width=600&height=900&seq=gydb-c11&orientation=portrait",
    summary: "拜访散落各地的老手艺人，记录一门手艺如何与一个人相守一生。",
    description: [
      "做了一辈子木匠的老师傅、守着染坊四十年的夫妻、修复古琴的年轻匠人——他们做的都是慢工，也都是闲不住的心里话。",
      "纪录片不追求宏大叙事，只想在一双手的动作里，留住那些正在消失的耐心。",
    ],
    views: 24180,
    updatedAt: "2026-07-14",
    rating: 8.5,
  },
  {
    id: "biandi-xingji",
    title: "边地行纪",
    categoryId: "doc",
    region: "中国大陆",
    year: 2021,
    genres: ["历史"],
    tags: ["国语对白", "高清", "时代记忆", "口碑"],
    director: "宋延之",
    cast: ["旁白 何越"],
    cover: "https://readdy.ai/api/search-image?query=remote%20highland%20village%20beneath%20snow%20mountains%2C%20travel%20documentary%20poster%2C%20cool%20blue%20tones%20with%20warm%20sunlight%20on%20rooftops%2C%20vast%20serene%20atmosphere&width=600&height=900&seq=gydb-c12&orientation=portrait",
    summary: "走进地图边缘的那些村镇，听边地人讲他们与土地的长久约定。",
    description: [
      "摄制组沿着国境线行走，探访雪山脚下、大漠边缘与海岛尽头的村镇，记录那里独特的生活方式与语言。",
      "边地并不意味着遥远，它只是另一种节奏的生活。十二集行纪，献给所有认真生活的人。",
    ],
    views: 21840,
    updatedAt: "2026-05-30",
    rating: 8.7,
  },
  {
    id: "jinye-haoliao",
    title: "今夜好聊",
    categoryId: "variety",
    region: "中国大陆",
    year: 2024,
    genres: ["喜剧"],
    tags: ["国语对白", "治愈", "口碑", "连载中"],
    director: "总导演 郑一鸣",
    cast: ["主持人 方知夏", "常驻 沈括", "常驻 林可"],
    cover: "https://readdy.ai/api/search-image?query=warm%20talk%20show%20studio%20with%20sofa%20and%20soft%20spotlights%2C%20tv%20variety%20poster%2C%20warm%20orange%20with%20deep%20blue%20background%2C%20cozy%20intimate%20atmosphere&width=600&height=900&seq=gydb-c13&orientation=portrait",
    summary: "深夜档谈话综艺，把成年人不好意思说出口的话，慢慢聊开。",
    description: [
      "每期请来三位不同领域的嘉宾，围绕一个生活话题展开没有脚本的夜谈，从失恋聊到中年，从故乡聊到理想。",
      "节目单集时长六十分钟，节奏舒缓，适合睡前观看。三季节目中，有笑点也有忽然沉默的真诚时刻。",
    ],
    views: 67210,
    updatedAt: "2026-10-06",
    rating: 8.9,
  },
  {
    id: "chufa-ba-shaonian",
    title: "出发吧少年",
    categoryId: "variety",
    region: "中国大陆",
    year: 2023,
    genres: ["喜剧"],
    tags: ["国语对白", "热血", "口碑", "已完结"],
    director: "总导演 韦然",
    cast: ["常驻 陆星野", "常驻 江小满", "常驻 顾桥"],
    cover: "https://readdy.ai/api/search-image?query=youth%20travel%20variety%20show%20poster%20with%20backpacks%20on%20a%20mountain%20trail%2C%20energetic%20mood%2C%20bright%20blue%20sky%20with%20warm%20sunlight%2C%20optimistic%20atmosphere&width=600&height=900&seq=gydb-c14&orientation=portrait",
    summary: "六位少年的公路旅行，把青春的莽撞和友谊一并装进后备箱。",
    description: [
      "节目组把六位年轻人丢在一辆车里，给一张地图和有限预算，让他们自己决定路线，自己解决一路上的所有问题。",
      "有争执也有和解，有迷路也有惊喜。十二期旅程录下的，是青春里最不怕犯错的那一段路。",
    ],
    views: 49360,
    updatedAt: "2026-08-09",
    rating: 8.3,
  },
  {
    id: "shengyin-de-lvxing",
    title: "声音的旅行",
    categoryId: "variety",
    region: "中国台湾",
    year: 2022,
    genres: ["喜剧"],
    tags: ["国语对白", "治愈", "口碑", "已完结"],
    director: "总导演 吴柏成",
    cast: ["主持人 温以恒", "嘉宾 林知晓"],
    cover: "https://readdy.ai/api/search-image?query=recording%20studio%20with%20vintage%20microphones%20and%20warm%20lamp%20light%2C%20music%20variety%20poster%2C%20deep%20blue%20room%20with%20golden%20highlights%2C%20intimate%20atmosphere&width=600&height=900&seq=gydb-c15&orientation=portrait",
    summary: "带一位歌手去一座陌生的城，把那里的声音写成一首歌。",
    description: [
      "每一期，主持人陪同一组音乐人前往一座陌生的城市，用三天时间采集当地的市声、方言与故事，最终完成一首原创作品。",
      "节目把创作过程完整呈现，也把城市最真实的声音留了下来。十六期节目，就是十六首关于地方的歌。",
    ],
    views: 30150,
    updatedAt: "2026-06-25",
    rating: 8.4,
  },
  {
    id: "shenghuo-guanchashi",
    title: "生活观察室",
    categoryId: "variety",
    region: "中国大陆",
    year: 2025,
    genres: ["都市"],
    tags: ["国语对白", "新片", "治愈", "连载中"],
    director: "总导演 韩雪岭",
    cast: ["主持人 苏漾", "观察员 孟然", "观察员 何思远"],
    cover: "https://readdy.ai/api/search-image?query=modern%20cozy%20living%20room%20set%20with%20cameras%20and%20warm%20lighting%2C%20reality%20show%20poster%2C%20warm%20neutrals%20with%20deep%20blue%20accents%2C%20welcoming%20atmosphere&width=600&height=900&seq=gydb-c16&orientation=portrait",
    summary: "在镜头里记录普通人的一周，再回到演播室聊他们为什么这样生活。",
    description: [
      "节目邀请素人参与，用一周时间记录他们的真实生活，随后由观察员与观众一起回看，讨论藏在日常里的选择与情绪。",
      "没有剧本，没有煽情剪辑，只有真实的烟火与困惑。它想说的很简单：每一种生活都值得被认真看见。",
    ],
    views: 55830,
    updatedAt: "2026-10-08",
    rating: 8.6,
  },
  {
    id: "xinghai-shiyi",
    title: "星海拾遗",
    categoryId: "anime",
    region: "中国大陆",
    year: 2024,
    genres: ["科幻", "剧情"],
    tags: ["国语对白", "新片", "热血", "连载中"],
    director: "导演 纪云帆",
    cast: ["配音 沈星野", "配音 林以南", "配音 韩知夏"],
    cover: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20young%20pilot%20before%20a%20vast%20starry%20galaxy%2C%20vivid%20blue%20nebula%20with%20warm%20orange%20highlights%2C%20epic%20adventurous%20illustration%20style&width=600&height=900&seq=gydb-c17&orientation=portrait",
    summary: "在废弃的星舰残骸里，少年拾回的不只是零件，还有被遗忘的星图。",
    description: [
      "银河边缘的回收站里，少年叶星拾到一块会发光的导航芯片，芯片里封存着一张不存在的星图，指向一颗被历史抹去的行星。",
      "为了寻找答案，他修好一艘旧星舰，带着伙伴驶向星海深处。这是一部关于探索与传承的国产科幻动画。",
    ],
    views: 42150,
    updatedAt: "2026-09-24",
    rating: 8.9,
  },
  {
    id: "shanhai-xiaoyao",
    title: "山海小妖",
    categoryId: "anime",
    region: "中国大陆",
    year: 2023,
    genres: ["剧情"],
    tags: ["国语对白", "治愈", "口碑", "已完结"],
    director: "导演 白鹿川",
    cast: ["配音 苏小小", "配音 陆明川", "配音 江雪宁"],
    cover: "https://readdy.ai/api/search-image?query=charming%20anime%20poster%20of%20a%20tiny%20mischievous%20spirit%20in%20a%20misty%20mountain%20forest%2C%20vivid%20colors%20with%20blue%20mist%20and%20warm%20glow%2C%20whimsical%20illustration&width=600&height=900&seq=gydb-c18&orientation=portrait",
    summary: "一只没见过世面的小山妖，误打误撞开始了寻找同类的旅途。",
    description: [
      "在山海经里的山林深处，小妖阿谣自出生起就独自生活。一次意外让她走出山谷，踏上寻找同类的旅程。",
      "一路遇见形形色色的妖怪与凡人，她逐渐明白：所谓同类，不一定长得一样，而是愿意彼此理解。",
    ],
    views: 37640,
    updatedAt: "2026-08-02",
    rating: 8.7,
  },
  {
    id: "jian-yu-shaonian",
    title: "剑与少年",
    categoryId: "anime",
    region: "中国大陆",
    year: 2022,
    genres: ["武侠", "动作"],
    tags: ["国语对白", "热血", "经典", "已完结"],
    director: "导演 秦无衣",
    cast: ["配音 顾长风", "配音 沈青崖", "配音 白小满"],
    cover: "https://readdy.ai/api/search-image?query=anime%20poster%20of%20a%20young%20swordsman%20on%20a%20cliff%20at%20sunset%2C%20ink%20wash%20style%2C%20deep%20blue%20sky%20with%20warm%20orange%20clouds%2C%20dynamic%20epic%20illustration&width=600&height=900&seq=gydb-c19&orientation=portrait",
    summary: "背负师门之仇的少年，用一柄断剑走出属于自己的剑道。",
    description: [
      "少年白小满师门被灭那夜，只带走了一柄折断的剑。十年后他重返江湖，却发现仇人的身影与自己想象中截然不同。",
      "刀光剑影之外，这部动画更想讲的是：一个人要经历多少，才能分清仇恨与是非。",
    ],
    views: 29870,
    updatedAt: "2026-07-07",
    rating: 8.5,
  },
  {
    id: "yunduan-xinxiang",
    title: "云端信箱",
    categoryId: "anime",
    region: "中国大陆",
    year: 2021,
    genres: ["家庭", "剧情"],
    tags: ["国语对白", "治愈", "温情", "已完结"],
    director: "导演 温以宁",
    cast: ["配音 林知夏", "配音 周爷爷", "配音 阿布"],
    cover: "https://readdy.ai/api/search-image?query=heartwarming%20anime%20poster%20of%20a%20girl%20and%20an%20old%20grandfather%20under%20a%20big%20tree%20with%20floating%20letters%2C%20soft%20pastel%20blue%20sky%20with%20warm%20light%2C%20gentle%20whimsical%20illustration&width=600&height=900&seq=gydb-c20&orientation=portrait",
    summary: "爷爷留下的旧信箱能收到天上的来信，孙女决定一一回信。",
    description: [
      "爷爷去世后，女孩知夏在他旧书房里发现一个奇怪的木信箱。每到夜里，信箱里就会多出一封字迹熟悉的信。",
      "她开始给这些信回信，也慢慢拼凑出爷爷没说出口的一生。这是一部关于告别与传承的温柔动画。",
    ],
    views: 25410,
    updatedAt: "2026-05-18",
    rating: 8.8,
  },
  {
    id: "sanfenzhong-lianren",
    title: "三分钟恋人",
    categoryId: "short",
    region: "中国大陆",
    year: 2024,
    genres: ["爱情", "剧情"],
    tags: ["国语对白", "新片", "治愈", "口碑"],
    director: "导演 林一舟",
    cast: ["沈知白", "柳安然"],
    cover: "https://readdy.ai/api/search-image?query=cinematic%20short%20film%20poster%20of%20two%20people%20in%20a%20phone%20booth%20under%20blue%20dusk%20light%20with%20warm%20glow%2C%20intimate%20romantic%20mood%2C%20minimal%20composition&width=600&height=900&seq=gydb-c21&orientation=portrait",
    summary: "一座电话亭，两个陌生人，约定每天只相爱三分钟。",
    description: [
      "深夜的老街转角有一座废弃电话亭，男女主角约定每晚在这里见面，但每次只相处三分钟，铃声一响就各自离开。",
      "三分钟能说什么？又能记住什么？短片的答案，藏在最后一次没有响起的铃声里。",
    ],
    views: 31240,
    updatedAt: "2026-09-15",
    rating: 8.6,
  },
  {
    id: "moban-ditie",
    title: "末班地铁",
    categoryId: "short",
    region: "中国大陆",
    year: 2023,
    genres: ["悬疑", "剧情"],
    tags: ["国语对白", "烧脑", "高清", "口碑"],
    director: "导演 江渡",
    cast: ["何未晞", "陆一鸣"],
    cover: "https://readdy.ai/api/search-image?query=empty%20subway%20carriage%20at%20night%20with%20cold%20blue%20lighting%20and%20one%20passenger%2C%20mysterious%20short%20film%20poster%2C%20cinematic%20moody%20atmosphere&width=600&height=900&seq=gydb-c22&orientation=portrait",
    summary: "末班地铁上只剩一名乘客，可广播却一遍遍报着不存在的站名。",
    description: [
      "加班到深夜的上班族赶上了末班地铁，车厢里空无一人。当广播报出地图上根本不存在的站名时，他发现车门已经无法打开。",
      "短片用二十分钟构建了一个封闭的悬念空间，结局的两个镜头，值得反复回看。",
    ],
    views: 28760,
    updatedAt: "2026-08-18",
    rating: 8.4,
  },
  {
    id: "yeye-de-shouyinji",
    title: "爷爷的收音机",
    categoryId: "short",
    region: "中国台湾",
    year: 2022,
    genres: ["家庭", "剧情"],
    tags: ["国语对白", "温情", "治愈", "时代记忆"],
    director: "导演 许安",
    cast: ["陈柏宇", "林奶奶"],
    cover: "https://readdy.ai/api/search-image?query=vintage%20radio%20on%20a%20wooden%20table%20by%20a%20window%20with%20warm%20afternoon%20light%2C%20nostalgic%20short%20film%20poster%2C%20warm%20sepia%20with%20soft%20blue%20shadow%2C%20tender%20atmosphere&width=600&height=900&seq=gydb-c23&orientation=portrait",
    summary: "孙子修好一台旧收音机，却听见了爷爷年轻时的声音。",
    description: [
      "整理旧物时，孙子阿宇翻出爷爷留下的老式收音机。零件早已锈蚀，他花了整个夏天把它修好。",
      "开机那晚，收音机里传出的不是电台，而是爷爷年轻时录下的一段段独白。短片讲述一段跨越时间的祖孙对话。",
    ],
    views: 22680,
    updatedAt: "2026-06-11",
    rating: 8.7,
  },
  {
    id: "wuding-shang-de-feng",
    title: "屋顶上的风",
    categoryId: "short",
    region: "新加坡",
    year: 2025,
    genres: ["剧情", "家庭"],
    tags: ["国语对白", "新片", "治愈", "口碑"],
    director: "导演 陈明轩",
    cast: ["黄思远", "李佳宁"],
    cover: "https://readdy.ai/api/search-image?query=rooftop%20of%20an%20old%20apartment%20at%20golden%20hour%20with%20laundry%20lines%2C%20cinematic%20short%20film%20poster%2C%20warm%20orange%20sunset%20with%20deep%20blue%20sky%2C%20nostalgic%20tender%20atmosphere&width=600&height=900&seq=gydb-c24&orientation=portrait",
    summary: "搬家前最后一天，父子俩在天台上把没说出口的话讲完。",
    description: [
      "老组屋即将拆除，父子俩回来收拾最后的行李。傍晚，两人一起爬上从未认真看过风景的天台。",
      "风把旧衣服吹得鼓起来，也把二十年来积压的沉默一点点吹散。短片用一天时间，完成一次迟到的和解。",
    ],
    views: 26930,
    updatedAt: "2026-10-09",
    rating: 8.8,
  },
];

export default contents;